function e(e,t,n){const r=e.toString();if("string"==typeof t){const e=new RegExp(t,"g");return r.replace(e,n)}return r.replace(t,n)}export{e as replaceAll};
